window.addEventListener('DOMContentLoaded', (ev) => {
	$ = jQuery.noConflict();

	if (typeof PixelsmithChildBlocks !== 'undefined') {
		for (const key in PixelsmithChildBlocks) {
			if (PixelsmithChildBlocks.hasOwnProperty(key)) {

				if (PixelsmithBlocks[key]) {
					delete PixelsmithBlocks[key];
				}

				const block = PixelsmithChildBlocks[key];
				block.init();
			}
		}
	}

	if (typeof PixelsmithChildModules !== 'undefined') {
		for (const key in PixelsmithChildModules) {
			if (PixelsmithChildModules.hasOwnProperty(key)) {

				if (PixelsmithModules[key]) {
					delete PixelsmithModules[key];
				}

				const block = PixelsmithChildModules[key];
				block.init();
			}
		}
	}

});
